import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import registerServiceWorker from './registerServiceWorker';
import ReactGA from 'react-ga';

import AppContainer from './AppContainer';
import About from './pages/About';
import Home from './pages/Home/HomeContainer';
import Footer from './components/Footer';
import FourOhFour from './pages/FourOhFour';
import JoinContainer from './pages/Join/JoinContainer';
import Pricing from './pages/Pricing';

import User from './pages/User';
import ProfileContainer from './pages/Profile/ProfileContainer';
import ChatsContainer from './pages/Chats/ChatsContainer';
import Chat from './pages/Chat';

// Admin
import JobsContainer from './pages/Jobs/JobsContainer';
import AddJobContainer from './pages/AddJob/AddJobContainer';
import EditJobContainer from './pages/EditJob/EditJobContainer';
import ApplicantsContainer from './pages/Applicants/ApplicantsContainer';
import SettingsContainer from './pages/Settings/SettingsContainer';
import Applicant from './pages/Applicant';
import PayoutsContainer from './pages/Payouts/PayoutsContainer';
import PayoutContainer from './pages/Payout/PayoutContainer';
import BatchInvitesContainer from './pages/BatchInvites/BatchInvitesContainer';
import BatchInvite from './pages/BatchInvite';
import Hire from './pages/Hire';
import AdminContainer from './pages/Admin/AdminContainer';

// NonAdmin
import Offer from './pages/Offer';
import MyOffers from './pages/MyOffers';
import ApplicationsContainer from './pages/Applications/ApplicationsContainer';
import CommissionsContainer from './pages/Commissions/CommissionsContainer';
import Commission from './pages/Commission';
import FavoritesContainer from './pages/Favorites/FavoritesContainer';
import InvitesContainer from './pages/Invites/InvitesContainer';
import DashboardContainer from './pages/Dashboard/DashboardContainer';

import createHistory from 'history/createBrowserHistory';

import { HashRouter, Route, Switch } from 'react-router-dom';
// Link,
// Redirect,

import { Provider } from 'react-redux';

import { configureStore } from './redux/store.js';

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('../firebase-messaging-sw.js')
//   .then(function(registration) {
//     console.log('Registration successful, scope is:', registration.scope);
//   }).catch(function(err) {
//     console.log('Service worker registration failed, error:', err);
//   });
// }

ReactGA.initialize('UA-106694645-1');

const history = createHistory();
ReactGA.pageview(history.location.hash);

history.listen((location, action) => {
	ReactGA.set({ page: location.hash });
	ReactGA.pageview(location.hash);

	setTimeout(() => {
		if (location.action === 'POP') return;
		else {
			// if (window.location.hash) {
			// 	var element = document.getElementById('app');
			// 	if (element) {
			// 		element.scrollIntoView({ block: 'start', behavior: 'smooth' });
			// 	}
			// } else {
			// document.getElementById('app').scrollIntoView({ block: 'start', behavior: 'smooth' })
			window.scrollTo(0, 0);
			// }
		}
	}, 1);
});

const store = configureStore();

ReactDOM.render(
	<Provider store={store}>
		<HashRouter history={history}>
			<div>
				<Route path="/" component={AppContainer} />
				<Switch>
					<Route exact path="/" component={Home} />
					<Route path="/Offer/:oid" component={Offer} />
					<Route path="/Applicants/:jid" component={ApplicantsContainer} />
					<Route path="/Applicant/:jid/:uid" component={Applicant} />
					<Route path="/Dashboard" component={DashboardContainer} />
					<Route path="/Profile" component={ProfileContainer} />
					<Route path="/Offers" component={MyOffers} />
					<Route path="/Jobs" component={JobsContainer} />
					<Route path="/AddJob" component={AddJobContainer} />
					<Route path="/EditJob/:jid" component={EditJobContainer} />
					<Route path="/Applications" component={ApplicationsContainer} />
					<Route path="/Commissions" component={CommissionsContainer} />
					<Route path="/Favorites" component={FavoritesContainer} />
					<Route path="/Commission/:jid" component={Commission} />
					<Route path="/About" component={About} />
					<Route path="/Payouts" component={PayoutsContainer} />
					<Route path="/Payout/:jid" component={PayoutContainer} />
					<Route path="/Invites" component={InvitesContainer} />
					<Route path="/Chats" component={ChatsContainer} />
					<Route path="/Chat/:rid" component={Chat} />
					<Route path="/Admin" component={AdminContainer} />
					<Route path="/Settings" component={SettingsContainer} />
					<Route path="/BatchInvites" component={BatchInvitesContainer} />
					<Route path="/BatchInvite/:oid" component={BatchInvite} />
					<Route path="/User/:uid" component={User} />
					<Route path="/Join" component={JoinContainer} />
					<Route path="/Hire/:jid/:uid" component={Hire} />
					<Route path="/Pricing" component={Pricing} />
					<Route component={FourOhFour} />
				</Switch>
				<Footer />
			</div>
		</HashRouter>
	</Provider>,
	document.getElementById('root')
);
registerServiceWorker();

// <Route path="/*" component={FourOhFour} />
// <Route path="/Estimate" component={Estimate} />
// <Route path="/Apply/:oid" component={Apply} />



// WEBPACK FOOTER //
// ./src/index.js